"use strict";

import "promise-polyfill/src/polyfill";
import "whatwg-fetch";

import React from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { i18n } from "../i18n/i18next";
import { MantineRoot } from "./MantineRoot";

const mountDivName = "react-container";
let container;

export function standaloneRender(Component) {
    if (container) {
        return;
    }

    container = document.getElementById(mountDivName);
    const root = createRoot(container);
    root.render(
        <I18nextProvider i18n={i18n}>
            <MantineRoot>
                <Component />
            </MantineRoot>
        </I18nextProvider>
    );
}
